import { render, staticRenderFns } from "./TableActivityLog.vue?vue&type=template&id=94a1b522&scoped=true&"
import script from "./TableActivityLog.vue?vue&type=script&lang=js&"
export * from "./TableActivityLog.vue?vue&type=script&lang=js&"
import style0 from "./TableActivityLog.vue?vue&type=style&index=0&id=94a1b522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a1b522",
  null
  
)

export default component.exports